export default function (context, value) {
    context.dispatch('settings/open', 'paymentItems', {root: true});
}